import { motion } from "framer-motion";
import styled from "styled-components";
import { formatDate, formatFileSize, getDocumentFileType } from "./DocumentUtils";
import { FiDownload, FiFileText, FiTrash } from "react-icons/fi";

export const DocumentListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const DocumentListTitle = styled.h3`
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text-primary, #000);
`;

export const DocumentListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const DocumentItemStyled = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid var(--border-color, #e0e0e0);
  border-radius: 8px;
  background: white;
  cursor: ${(props) => (props.hasLink ? 'pointer' : 'default')};
  transition: all 0.2s ease;
  opacity: ${(props) => (props.hasLink ? 1 : 0.6)};

  &:hover {
    ${(props) =>
      props.hasLink
        ? `
      background: var(--bg-hover, #f8f9fa);
      border-color: var(--primary, #007bff);
      box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);
      transform: translateX(4px);
    `
        : `
      opacity: 0.6;
    `}
  }

  &:active {
    transform: translateX(2px);
  }
`;

export const DocumentIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: var(--bg-secondary, #f0f0f0);
  color: var(--primary, #007bff);
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const DocumentInfoWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`;

export const DocumentTitleStyled = styled.h4`
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary, #000);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DocumentMetaStyled = styled.p`
  margin: 0;
  font-size: 0.8rem;
  color: var(--text-secondary, #999);
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;

  span {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }
`;

export const DocumentActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--text-secondary, #666);
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;


  &:hover {
    background: var(--bg-hover, #f0f0f0);
    color: var(--primary, #007bff);

  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

    // color:  ${props => props.danger ? 'red' : 'var(--primary, #007bff)'}

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
  color: var(--text-secondary, #999);
  background: var(--bg-secondary, #f8f9fa);
  border-radius: 8px;
  border: 1px dashed var(--border-color, #ddd);

  svg {
    width: 48px;
    height: 48px;
    margin-bottom: 1rem;
    color: var(--border-color, #ddd);
  }

  h4 {
    margin: 0 0 0.5rem 0;
    color: var(--text-primary, #000);
    font-size: 1rem;
  }

  p {
    margin: 0;
    font-size: 0.9rem;
  }
`;

export const DocumentItem = ({
  document,
  onDocumentClick,
  onDownload,
  hasLink,
}) => {
  const handleClick = () => {
    if (hasLink) {
      onDocumentClick(document);
    }
  };

  const handleDownloadClick = (e) => {
    e.stopPropagation();
    if (onDownload) {
      onDownload(document);
    }
  };

  return (
    <DocumentItemStyled
      hasLink={hasLink}
      onClick={handleClick}
      whileHover={{ scale: 0.99 }}
      whileTap={{ scale: 0.98 }}
    >
      <DocumentIconWrapper>
        {/* {getIconComponent(document.file_name || document.name || document.url)} */}
        <FiFileText style={{color:'red'}} />
      </DocumentIconWrapper>

      <DocumentInfoWrapper>
        <DocumentTitleStyled title={document.fileName || document.name}>
          {document.fileName || document.name}
        </DocumentTitleStyled>
        <DocumentMetaStyled>
          <span>{getDocumentFileType(document.fileName || document.name)}</span>
          <span>•</span>
          <span>{formatFileSize(document.size)}</span>
          <span>•</span>
          <span>{formatDate(document.updated_at || document.created_at)}</span>
        </DocumentMetaStyled>
      </DocumentInfoWrapper>

      {onDownload && (
        <DocumentActionButton
          onClick={handleDownloadClick}
          title="Download document"
        >
          <FiDownload />
        </DocumentActionButton>
      )}
      {/* <DocumentActionButton
       title="Remvoe document"

      >
        <FiTrash />
      </DocumentActionButton> */}
    </DocumentItemStyled>
  );
};